<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { auto_assign_on_reply_enabled } =
      currentAccount.value?.settings || {};
    isEnabled.value = auto_assign_on_reply_enabled === true || auto_assign_on_reply_enabled === 'true';
  },
  { deep: true, immediate: true }
);

const toggleAutoAssignOnReply = async () => {
  try {
    await updateAccount(
      { auto_assign_on_reply_enabled: isEnabled.value },
      { silent: true }
    );
    useAlert(t('GENERAL_SETTINGS.FORM.AUTO_ASSIGN_ON_REPLY.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.AUTO_ASSIGN_ON_REPLY.API.ERROR'));
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.AUTO_ASSIGN_ON_REPLY.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.AUTO_ASSIGN_ON_REPLY.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleAutoAssignOnReply" />
      </div>
    </template>
  </SectionLayout>
</template>
